import 'babel-polyfill';

$.extend($.expr[":"], {
    "icontains": function (elem, i, match, array) {
        return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
    }
});

$(function () {
    $(".mobilenav_button, .mainnav_closebutton").click(function () {
        $("header").toggleClass("header--shownav");
    });

    // Not used
    $(".fancybox-iframe").fancybox({
            type: 'iframe'
        }
    );

    // Only used in project detail view
    $(".fancybox").fancybox({
        type: 'ajax',
        afterShow: function () {
            $("#status").select2();
            $(".message-links a").click(function (e) {
                var messageid = "#text-" + this.id;
                $("#message").val($.trim($(messageid).html().replace(/(<([^>]+)>)/ig, "")));
            });
        }
    });

    $('option[value*="region"]').css({
        fontWeight: 'bold'
    });

    /*    $("#voteButton").each(function() {
            var fp = new XFP({canvas: true, screen_resolution:true}).get();
            this.href = this.href+"?fp="+fp;
        })
    */
    var fp = new XFP({canvas: true, screen_resolution: true}).get();

    $("#voteButton").click(function () {
        $.ajax({
            url: "/fingerprint/" + fp
        });
        return true;
    });


    //TBD: https://github.com/cirykpopeye/selectra
    $("#citymenu").select2({
        placeholder: "Alle Städte...",
        formatNoMatches: function (term) {
            return "Nichts gefunden.";
        },
        formatSearching: function () {
            return "Suche...";
        }
    }).change(function (e) {
        this.form.submit();
    });


    $("#adminfilter").change(function () {
        if (this.value) {
            $(".projects article").hide();
            $('.projects article .orga:icontains("' + this.value + '")').parent().parent().show();
        } else {
            $(".projects article").show();
        }
    });

    $('.field--iban').mask('SS00 0000 0000 0000 0000 00', {
        placeholder: 'DE__ ____ ____ ____ ____ __'
    }).on('focus', function () {
        if (this.value === "") {
            this.value = "DE";
        }
    }).on('blur', function () {
        if (this.value === "DE") {
            this.value = "";
        }
    });


//Can we move this to voting?


});

window.initPopup = function (url) {
    $('.nolike').click(function (e) {
        e.preventDefault();
        $('.facebook_popup').remove();
    });

    $.ajax({
        url: url
    }).done(function (data) {
        //console.log(data);
    });
};

import ProjectMap from "./components/Map/ProjectMap";
import VoteBox from "./components/VoteBox/VoteBox";
import Loader from "./loader";

$(function () {
    const loader = new Loader();
    loader.register("VoteBox", VoteBox);
    loader.register('ProjectMap', ProjectMap);

    loader.init(window.document);
});
